<li class="approval-item row {{ getColorClass() }}">
  <div class="top-data col-12 row nowrap">
    <span class="col-5 col-sm-3 col-xl-1">{{ approvalType.name }}</span>
    <span class="row nowrap col-4 col-md-2">
      <span class="col-3 col-md-2 col-xl-1 row">
        @if (isMilestoneMember) {
          <mat-icon class="indicator">{{
            getIconName()
          }}</mat-icon>
        }
      </span>
      @if (isMilestoneMember) {
        <select
          #statusSelect
          class="col-9 col-md-8"
          [ngModel]="$safeNavigationMigration(approval?.status)"
          (ngModelChange)="onSelectApproval(statusSelect.value)"
          ngDefaultControl
        [disabled]="
          !approvalType.permissions?._edit || approvalService.isLoading(projectId) || readOnly
        "
          >
          @for (status of statusKeys; track status) {
            @if (shouldShow(status, items)) {
              <option [value]="statuses[status]">
                {{ status }}
              </option>
            }
          }
        </select>
      }
    </span>
    <span class="creator hide show-sm col-sm-4 col-md-3 col-lg-6 col-xl-7"
      >{{ approval?.user?.person ? approval?.user?.person?.name + ": " : ""
      }}{{ getDateString() }}</span
      >
      <span class="row justify-flex-end items-controls col-4 col-md-5 col-lg-2">
        @if (
          approvalType.permissions?._edit && !readOnly
          ) {
          <a
            href="#"
            (click)="addItem($event)"
            class="add-item col-3 col-md-4"
            ><span class="hide show-md">Add Item</span
            ><mat-icon class="hide-md">add</mat-icon>
            @if (this.filteredItems().length) {
              <span class="item-count">
                ({{ this.filteredItems().length }})
              </span>
            }
          </a>
        }

        @if (this.filteredItems().length) {
          <button
            type="button"
            class="collapse-button {{ showItemsClass() }} col-3 col-sm-2 col-xl-1"
            (click)="showItems = !showItems"
            >
            <mat-icon>expand_more</mat-icon>
          </button>
        }
      </span>
    </div>
    <div class="row col-12 committee-items {{ showItemsClass() }}">
      <app-committee-items
        [projectId]="projectId"
        [approvalType]="approvalType"
        [approvalTypes]="approvalTypes"
        [headerColumns]="headerColumns"
        [milestoneContext]="milestoneId"
        [milestoneName]="milestoneName"
        [readOnly]="readOnly"
      ></app-committee-items>
    </div>
  </li>
